import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bcf57df0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "questionsSubmitView" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"orange"}
}
const _hoisted_3 = {
  key: 1,
  style: {"color":"orange"}
}
const _hoisted_4 = {
  key: 2,
  style: {"color":"green"}
}
const _hoisted_5 = {
  key: 3,
  style: {"color":"orangered"}
}

import { onMounted, ref, watchEffect } from "vue";
import {
  Question,
  QuestionControllerService,
  QuestionQueryRequest,
  QuestionSubmitQueryRequest,
} from "../../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionsSubmitView',
  setup(__props) {

const router = useRouter();

const show = ref(true);

const dataList = ref([]);
const total = ref(0);
const searchParas = ref<QuestionSubmitQueryRequest>({
  // 查询条件
  questionId: undefined,
  language: undefined,
  pageSize: 10, // 每页题目数
  current: 1,
});

/**
 *  分页获取 题目数据
 */
const loadData = async () => {
  const res =
    await QuestionControllerService.listQuestionSubmitVoByPageUsingPost({
      // 创建时间降序排序
      ...searchParas.value,
      sortField: "createTime",
      sortOrder: "descend",
    });
  console.log(res.data);
  // 查询结果为0
  if (res.code === 0) {
    dataList.value = res.data.records; // 数据条数
    total.value = res.data.total; // 数据总数
  } else {
    message.error("加载失败，" + res.message);
  }
};

/**
 *  页面加载时 请求数据
 */
onMounted(() => {
  loadData();
});

const columns = [
  {
    title: "提交号",
    dataIndex: "id",
  },
  {
    title: "题目",
    slotName: "questionTitle",
  },
  {
    title: "编程语言",
    dataIndex: "language",
  },
  {
    title: "运行状态",
    slotName: "status",
  },
  {
    title: "通过",
    slotName: "judgeInfoMessage",
  },
  {
    title: "运行时间",
    slotName: "judgeInfoTime",
  },
  // {
  //   title: "运行内存",
  //   slotName: "judgeInfoMemory",
  // },
  {
    title: "提交用户",
    slotName: "userName",
  },
  {
    title: "提交时间",
    slotName: "createTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];

/**
 * 监听函数loadData
 *  若函数中有变量改变，程序执行该函数
 *   用于分页，当searchParas改变时，重新加载页面
 */
watchEffect(() => {
  loadData();
});

// 分页时更新页号
const onPageChange = (page: number) => {
  searchParas.value = {
    ...searchParas.value,
    current: page,
  };
};

/**
 *  跳转题目详情页
 * @param questionId
 */
const toQuestionPage = (questionId: number) => {
  // 路由跳转 get传id
  router.push({
    path: `/detail/question_submit/${questionId}`,
  });
};

/**
 *  题目模糊搜索
 *    搜索是对search修改，提交时 触发自动刷新
 */
const doSearch = () => {
  searchParas.value = {
    ...searchParas.value,
    current: 1, // 页号恢复到第一页
  };
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      class: "search",
      model: searchParas.value,
      layout: "inline"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "questionId",
          label: "题号",
          style: {"min-width":"280px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: searchParas.value.questionId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParas.value.questionId) = $event)),
              placeholder: "请输入题号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "language",
          label: "编程语言",
          style: {"min-width":"280px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              style: { width: '320px' },
              modelValue: searchParas.value.language,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParas.value.language) = $event)),
              placeholder: "请选择语言"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("java")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("cpp")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("python")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("html")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, { disabled: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode("go")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: doSearch
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        pageSize: searchParas.value.pageSize,
        current: searchParas.value.current,
        total: total.value,
      },
      onPageChange: onPageChange,
      style: {"margin":"0 20px"}
    }, {
      questionTitle: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(record.questionVO.title), 1)
      ]),
      status: _withCtx(({ record }) => [
        (record.status === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString("Waiting")))
          : (record.status === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString("Running")))
            : (record.status === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString("Finish")))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString("Warning")))
      ]),
      judgeInfoMessage: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (record.status === 0 || record.status === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_a_spin),
                  _createVNode(_component_a_tag, { color: "#86909c" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString("Loading"))
                    ]),
                    _: 1
                  })
                ], 64))
              : (record.judgeInfo.message === 'Accepted')
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "#7bc616"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(record.judgeInfo.message), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (record.judgeInfo.message === 'Wrong Answer')
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 2,
                      color: "red"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(record.judgeInfo.message), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : (record.judgeInfo.message === null)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 3,
                        color: "#86909c"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString("undefined"))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_tag, {
                        key: 4,
                        color: "#ff7d00"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(record.judgeInfo.message), 1)
                        ]),
                        _: 2
                      }, 1024))
          ]),
          _: 2
        }, 1024)
      ]),
      judgeInfoTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(record.judgeInfo.time + " ms"), 1)
      ]),
      userName: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(record.userVO.userName), 1)
      ]),
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD")), 1)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: ($event: any) => (toQuestionPage(record.questionId))
            }, {
              default: _withCtx(() => [
                _createTextVNode("查看 ")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination"])
  ]))
}
}

})